export default {
      id: "Icon--gallery-usage",
      viewBox: "0 0 24 24",
      url: __webpack_public_path__ + "sprite.svg#Icon--gallery",
      toString: function () {
        return this.url;
      }
    }